import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";
import ControlCenter from "@/views/ControlCenter.vue"
import ChangePassword from "@/components/User/ChangePassword.vue"
import DocumentManagement from "@/views/DocumentManagement.vue"
import HomeContent from "@/components/ControlCenter/HomeContent.vue"
import ShowDeviceData from "@/components/Device/ShowDeviceData.vue"
import RecordMalfunction from "@/components/HelpDesk/RecordMalfunction.vue";
import CreateCustomerDocuments from "@/components/Reports/CreateCustomerDocuments.vue";
import DocumentAccess from "@/components/Reports/DocumentAccess.vue";
import Stammdaten from "@/components/Stammdaten/Stammdaten.vue";
import People from "@/components/Stammdaten/People/People.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      {
        path: "/Content",
        name: "HomeContent",
        component: HomeContent,
      },
      {
        path: "/ControlCenter",
        name: "ControlCenter",
        component: ControlCenter,
      },
      {
        path: "/ChangePassword",
        name: "ChangePassword",
        component: ChangePassword,
      },
      {
        path: "/DocumentManagement",
        name: "DocumentManagement",
        component: DocumentManagement,
      },
      {
        path: "/DeviceData",
        name: "ShowDeviceData",
        component: ShowDeviceData,
      },
      {
        path: "/RecordMalFunction",
        name: "RecordMalfunction",
        component: RecordMalfunction,
      },
      {
        path: "/CreateCustomerDocuments",
        name: "CreateCustomerDocuments",
        component: CreateCustomerDocuments,
      },
      {
        path: "/Sos24AidInfo/:kundenLink",
        component: DocumentAccess,
        name: "customerLink",
        props: ["customerLink","Year"],
      },
      {
        path: "/Stammdaten",
        name: "Stammdaten",
        component: Stammdaten,
        children: [
          {
            path: "/Stammdaten//People",
            name: "People",
            component: People,
          }
        ]
      },
    ]
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
